import type {Translator} from '@yandex-delivery/core/i18n'
import type {Optional} from '@yandex-delivery/types'
import {applySpec, defaultTo, flow, get, ifElse, invert, toUndefined} from '@yandex-delivery/utils'
import {constant} from 'lodash'

import type {RequestBuyout, SddClaimRoutePoint, SourcePoint} from 'src/shared/types'
import {PaymentOnDemandType} from 'src/shared/types'
import {getPointId} from 'src/shared/utils'

import {dropEmptyValues} from './drop-empty-values'
import {fromPointAddressToAddress} from './from-point-address'
import {fromPointContact} from './from-point-contact'
import {getPointType} from './get-point-type'
import {modifyPointAddressComment} from './modify-point-address-comment'

const isSmsConfirmationSkipped: (point: SourcePoint) => boolean = flow(get('contact.isSmsConfirmationEnabled'), invert)

const toRequestBuyout: () => RequestBuyout = applySpec<RequestBuyout>({
  payment_method: constant(PaymentOnDemandType.Cash),
})

const isCashOnDelivery: (point: SourcePoint) => boolean = flow(get('cashOnDelivery'), defaultTo(false))

const toBuyout: (point: SourcePoint) => Optional<RequestBuyout> = ifElse(isCashOnDelivery, toRequestBuyout, toUndefined)

export const fromSddExpressSourcePoint = (t: Translator): ((point: SourcePoint) => SddClaimRoutePoint) =>
  applySpec<SddClaimRoutePoint>({
    address: flow(get('address'), modifyPointAddressComment, fromPointAddressToAddress, dropEmptyValues),
    buyout: toBuyout,
    contact: fromPointContact(t),
    point_id: getPointId,
    skip_confirmation: isSmsConfirmationSkipped,
    type: getPointType,
  })
